import React, { useState, useEffect } from 'react'
import { skipToken } from '@reduxjs/toolkit/query/react'
import Style from '../styles/pages/Reservation.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import PageHeader from '../components/layout/PageHeader'
import { Box, Typography, List, ListItem , Avatar} from '@mui/material'
import arrow from '../shared/images/arrow-down.svg'
import { RootState } from '../store/GlobalStore'
import { useGetUserReservationQuery} from '../services/ReservationAPI'
import { environment } from '../utils/Environment'
import { Reservation } from '../utils/Interface'
import calendar from '../shared/images/Icon awesome-calendar-alt.svg'
import people from '../shared/images/Icon material-people.svg'
import key from '../shared/images/Icon awesome-key.svg'
import plus from '../shared/images/Icon awesome-plus-square.svg'
import { useTranslation } from 'react-i18next';
const AllReservationsPage: React.FC = () => {
    const authState = useSelector((state: RootState) => state.Auth)
    const { t } = useTranslation();
     // Ne pas appeler la query si l'utilisateur n'est pas défini
     const userEmail = authState?.user?.email
     const [reservationData, setReservationData] = useState<Reservation[]>([]);
     const [activeTab, setActiveTab] = useState<'incoming' | 'past'>(
        () => (localStorage.getItem('activeTab') as 'incoming' | 'past') || 'incoming'
    );
     const [nbChilds, setNbChilds] = useState<number>(0);
     const [nbAdults, setNbAdults] = useState<number>(0);

     useEffect(() => {
        localStorage.setItem('activeTab', activeTab);
    }, [activeTab]);
    
    useEffect(() => {
       if(authState?.reservations !== null){
            const data = authState?.reservations
            console.log(data)
            // Filtrer les réservations selon l'onglet actif
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const filteredReservations = data.filter((reservation) => {
                const endDate = new Date(reservation.endDate);
                endDate.setHours(0, 0, 0, 0);
                return activeTab === 'incoming'
                    ? endDate >= today
                    : endDate < today;
            });

            console.log(filteredReservations)
        
            setReservationData(filteredReservations)
        }
    }, [authState?.reservations, activeTab]);
    

    return (
        <div className={Style.MainContainer}>
            <PageHeader backTo='/mon-compte' title={t('housing')} subtitle={t('housing_subtitle')} />
            <div>
            <div className={Style.Tabs}>
                <button
                    className={`${Style.incomingButton} ${activeTab === 'incoming' ? Style.active : ''}`}
                    onClick={() => setActiveTab('incoming')}
                >
                    {t('future')}
                </button>
                <button
                    className={`${Style.pastButton} ${activeTab === 'past' ? Style.active : ''}`}
                    onClick={() => setActiveTab('past')}
                >
                    {t('past')}
                </button>
            </div>
                <div className={Style.DesktopFormField}>
                    <Box className={Style.AccountBox}>
                    <List>
                    {reservationData.length > 0 ? (
                            reservationData.map((reservation, reservationIndex) => {
                                // Calculer les totaux des adultes et enfants pour la réservation actuelle
                                const { totalAdults, totalChildren } = reservation.Bookings.reduce(
                                  (acc, booking) => {
                                    if (!booking.cancelled) {
                                      acc.totalAdults += booking.nbAdults || 0;
                                      acc.totalChildren += booking.nbChilds || 0;
                                    }
                                    return acc;
                                  },
                                  { totalAdults: 0, totalChildren: 0 }
                                );
                          
                                return (
                                    <div key={`reservation-${reservationIndex}`} className={Style.ResaContainer}>
                                        <ListItem
                                            key={`${reservationIndex}`}
                                            className={Style.AnimationItem}
                                        >
                                            <div className={Style.TopAnimationContent}>
                                                {/*<img
                                                    src={`${process.env.REACT_APP_BASE_URL}${booking.displayImage}` || 'default-image.png'}
                                                    alt={booking.ressourceTypeCode}
                                                    className={Style.AnimationImage}
                                                />*/}
                                                <div className={Style.ResaTop}>
                                                    <div className={Style.Lieu}>Les Settons</div>
                                                    <Typography variant="body2" className={Style.strong}>
                                                        N° {reservation.asterioId}
                                                    </Typography>
                                                    </div>
                                                <div className={Style.AnimationInfoTop}>
                                                    <Typography variant="body2" className={Style.ResaDate}>
                                                        <img
                                                            src={calendar}
                                                            alt='calendar'
                                                            className={Style.AccountIcon}
                                                        />
                                                        <div>
                                                        {t('from')} {new Date(reservation.startDate).toLocaleDateString('fr-FR', {
                                                            month: 'short',
                                                            day: 'numeric'
                                                        })}{ ' ' +  t('to') + ' ' }
                                                        {new Date(reservation.endDate).toLocaleDateString('fr-FR', {
                                                            year: 'numeric',
                                                            month: 'short',
                                                            day: 'numeric'
                                                        })}
                                                        </div>
                                                    </Typography>
                                                    <Typography variant="body2" className={Style.ResaPeople}>
                                                    <div className={Style.InputContainer}>
                                                        <div className={Style.LabelContainer}>
                                                            <img
                                                                src={people}
                                                                alt='people'
                                                                className={Style.AccountIcon}
                                                            />
                                                            <div className={Style.Label}>{t('traveler')}(s)</div>
                                                        </div>
                                                        <div className={Style.DataContainer}>
                                                        <div className={Style.Data}>{totalAdults} {t('adults', { count: totalAdults })} ({t('18')})</div>
                                                        <div className={Style.Data}>{totalChildren} {t('children', { count: totalChildren })} ({t('4')})</div>
                                                        </div>
                                                    </div>
                                                    </Typography>
                                                    <Typography variant="body2" className={Style.ResaKey}>
                                                    <div className={Style.InputContainer}>
                                                        <div className={Style.LabelContainer}>
                                                            <img
                                                                src={key}
                                                                alt='key'
                                                                className={Style.AccountIcon}
                                                            />
                                                            <div className={Style.Label}>{t('access_code')}</div>
                                                        </div>
                                                        <div className={Style.DataContainer}>
                                                        <div className={Style.Data}>{t('barrier')} : {reservation.fenceCode || '-'}</div>
                                                        <div className={Style.Data}>{t('wc_code')} : {reservation.codeSanitaire || '-'}</div>
                                                        <div className={Style.Data}>
                                                            {t('waste_enclosure_code')} : {(reservation.wasteEnclosureCode && reservation.wasteEnclosureCode !== '-') ? reservation.wasteEnclosureCode : '-'}
                                                        </div>
                                                        <div className={Style.Data}>{t('room_access')}</div>

                                                        </div>
                                                    </div>
                                                    </Typography>
                                                    <Typography variant="body2" className={Style.ResaPlus}>
                                                    <img
                                                        src={plus}
                                                        alt='plus'
                                                        className={Style.AccountIcon}
                                                    />
                                                    <Link to={`/booking-options/${reservation.asterioId}`}>{t('presta')}</Link>
                                                    </Typography>
                                                    <Typography variant="body2" className={Style.ResaPrice}>
                                                    {(reservation.totalPayer > 0) ? 'Total : ' : ''}
                                                        {(reservation.totalPayer > 0) ? reservation.totalPayer  : ''} 
                                                        {(reservation.totalPayer > 0) ? '€' : ''}
                                                    </Typography>
                                                </div>
                                            </div>
                                            {/*<img src={arrow} alt='arrow' className={Style.ArrowIcon} />*/}
                                        </ListItem>
                                           {reservation.Bookings
                                           .filter((booking) => !booking.cancelled)
                                           .map((booking, bookingIndex) => (
                                            <ListItem
                                                key={`booking-${bookingIndex}`}
                                                className={`${Style.AllRoom} ${
                                                    false ? Style.cancelled : ''
                                                } ${bookingIndex === (reservation.Bookings.length - 1) ? Style.lastItem : ''}`}
                                                component={!booking.cancelled ? Link : 'div'}
                                                to={!booking.cancelled ? `/booking/${booking.bookingId}` : undefined}
                                            >
                                                <div className={Style.AllRoomMainRow}>
                                                    <div className={Style.AnimationContent}>
                                                        <img
                                                            src={`${process.env.REACT_APP_BASE_URL}${booking.displayImage}` || 'default-image.png'}
                                                            alt={booking.ressourceTypeCode}
                                                            className={Style.AnimationImage}
                                                        />
                                                        <div className={Style.AnimationInfo}>
                                                            <div className={Style.BookingTitleContainer}>
                                                                {/* Type d'hébergement (ex: Chalet 6 personnes) */}
                                                                <Typography variant="body2" className={Style.strong}>
                                                                    {booking.ressourceTypeLabel}
                                                                </Typography>

                                                                <Typography variant="body2" className={Style.AccommodationName}>
                                                                    {booking.ressourceLabel}
                                                                </Typography>
                                                                
                                                            </div>
                                                                <Typography variant="body2" className={Style.strong}>
                                                                    {reservation.Folios.find(
                                                                        (folio) => folio.productCode === booking.forfaitCode
                                                                    )?.unitPrice || ''}{' '}
                                                                    {reservation.Folios.find(
                                                                        (folio) => folio.productCode === booking.forfaitCode
                                                                    )
                                                                        ? '€ ' + t('by_night')
                                                                        : ''}
                                                                </Typography>
                                                                

                                                                <Typography variant="body2" className={Style.redStrong}>
                                                                    {booking.cancelled ? 'ANNULE' : ''}
                                                                </Typography>
                                                        </div>
                                                    </div>
                                                    <img src={arrow} alt="Détail" className={Style.ArrowIcon} />
                                                </div>
                                                {booking.attribution && (
                                                    <div className={Style.AttributionLine}>
                                                        {booking.attribution}
                                                    </div>
                                                )}
                                            </ListItem>
                                        ))}
                                    </div>
                            )})
                        ) : (
                            <Typography>
                                {activeTab === 'incoming' ? t('noFuture') : t('noPast')}
                            </Typography>
                        )}
                        </List>
                    </Box>
                </div>
            </div>
        </div>
    )
}

export default AllReservationsPage